module.exports = __webpack_public_path__ + "static/the-gulag-archipelago-volume-1-5e83d4e92ce6c203cc4f6d6e234b5fe1.jpg";